@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}

@if (!displayLineValueInSquares) {
    <div class="option-group-container over-under-container triple" [style.--option-group-rows]="visibleOptionGroups()">
        <div class="option-group-header">
            <span></span> <span>{{ optionGroup.parameterTranslations?.columnOver }}</span>
            <span>{{ optionGroup.parameterTranslations?.columnUnder }}</span>
        </div>
        <ng-container *rxFor="let group of visibleOptionGroups$; trackBy: trackGroup">
            <div class="attribute-key">
                {{ group.attribute }}
                @if (group.templateId && isMarketPromoted(group.optionGroupId, group.templateId)) {
                    <ms-promotion-badge class="no-title" />
                }
            </div>
            <ng-container *ngTemplateOutlet="commonMsOptions; context: { group }" />
        </ng-container>
    </div>
} @else {
    <div class="option-group-container over-under-container double" [style.--option-group-rows]="visibleOptionGroups()">
        <div class="option-group-header">
            <span>{{ optionGroup.parameterTranslations?.columnOver }}</span>
            <span>{{ optionGroup.parameterTranslations?.columnUnder }}</span>
        </div>
        <ng-container *rxFor="let group of visibleOptionGroups$; trackBy: trackGroup">
            <ng-container *ngTemplateOutlet="commonMsOptions; context: { group }" />
        </ng-container>
    </div>
}

@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}

<ng-template #commonMsOptions let-group="group">
    @for (option of group.options; track option.id) {
        <ms-option
            [option]="option"
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [optionGroup]="optionGroup"
            [event]="event"
            [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
            [sourceOfPick]="sourceOfPick"
            [betDetails]="betDetails" />
    }
</ng-template>
